import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function Shell() {
  return (
    <div className="min-h-screen bg-bg">
      <Sidebar />
      <div className="pl-64">
        <Topbar />
        <main className="relative">
          <div className="p-8 max-w-[1600px] mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
